import { BETTERSHOT_MAILTO_ADDRESS, PAGES } from "~/constants/app";
import { FaFacebookSquare, FaLinkedinIn, FaTiktok, FaTwitter } from "react-icons/fa";
import { AiFillInstagram } from "react-icons/ai";

export const menu = [
  {
    key: 1,
    title: "Contact",
    pages: [{ key: 1, title: "hello@bettershot.ai", url: BETTERSHOT_MAILTO_ADDRESS }],
  },
  {
    key: 2,
    title: "Learn",
    pages: [
      { key: 1, title: "How it works", url: `/#howitworks` },
      { key: 2, title: "FAQs", url: `/#faqs` },
    ],
  },
  {
    key: 3,
    title: "Legal",
    pages: [
      { key: 1, title: "Terms of Service", url: PAGES.TERMS_AND_CONDITIONS },
      { key: 2, title: "Privacy Policy", url: PAGES.POLICY },
    ],
  },
];

export const socialPages = [
  {
    key: 1,
    title: "Linkedin",
    icon: FaLinkedinIn,
    url: "https://www.linkedin.com/company/bettershot-ai/",
    size: "18px",
  },
  {
    key: 2,
    title: "Facebook",
    icon: FaFacebookSquare,
    url: "https://www.facebook.com/profile.php?id=61552825450756",
    size: "18px",
  },
  {
    key: 3,
    title: "Instagram",
    icon: AiFillInstagram,
    url: "https://www.instagram.com/bettershotai/",
    size: "20px",
  },
  {
    key: 4,
    title: "Tiktok",
    icon: FaTiktok,
    url: "https://www.tiktok.com/@bettershot",
    size: "15px",
  },
  {
    key: 5,
    title: "Twitter",
    icon: FaTwitter,
    url: "https://twitter.com/BettershotAI",
    size: "17px",
  },
];
